import { subjectsCardsActionTypes } from '.';

export const init = (view: StaticView) => ({
  type: subjectsCardsActionTypes.INIT,
  payload: { view },
} as const);

export const getData = (view: StaticView) => ({
  type: subjectsCardsActionTypes.GET_DATA_START,
  payload: { view },
} as const);
export const getDataNextPage = (view: StaticView) => ({
  type: subjectsCardsActionTypes.GET_DATA_NEXT_PAGE_START,
  payload: { view },
} as const);
export const getColumnsConfig = (view: StaticView) => ({
  type: subjectsCardsActionTypes.COLUMNS_GET_CONFIG_START,
  payload: { view },
} as const);
export const saveColumnsUserSetup = (view: StaticView, selectedColumns: SelectedColumns) => ({
  type: subjectsCardsActionTypes.COLUMNS_SAVE_USER_SETUP_START,
  payload: { view, selectedColumns },
} as const);
export const getRecordDetails = (view: StaticView, id: string | number) => ({
  type: subjectsCardsActionTypes.RECORD_GET_DETAILS_START,
  payload: { view, id },
} as const);
export const refreshData = (view: StaticView) => ({
  type: subjectsCardsActionTypes.REFRESH_DATA_START,
  payload: { view },
} as const);

export const changeWkdFilter = (view: StaticView, isWKD: boolean) => ({
  type: subjectsCardsActionTypes.CHANGE_WKD_FILTER,
  payload: { view, isWKD },
} as const);
